<app-header [isReadyForSignature]="isReadyForSignature" [slices]="slices" [pieIcons]="pieIcons"
  (praticaEvent)="onPraticaEvent($event)"></app-header>

<div class="router-container" style="margin-top: -310px; padding-bottom: 143px; position: relative; z-index: 4">
  <div class="status-bar">
    <app-status-bar *ngIf="!praticaProgressService.isOutcome"></app-status-bar>
    <app-score-summary *ngIf="praticaProgressService.isOutcome"></app-score-summary>
  </div>
  <router-outlet></router-outlet>
  <app-task-manager-button></app-task-manager-button>

</div>
<app-loader [isLoading]="isLoading$"></app-loader>